import { useState } from 'react';
import CalendarLogicDesign from './CalendarDesign';
import loading from '../../../assets/images/icons/refreshloader.gif';
import refreshicon from "../../../assets/images/icons/refresh.png";

const SESSION = {
  selectedZoneIDInCalendarScreen: 'selectedZoneIDInCalendarScreen',
  SelectedTranslation: 'selectedTranslation',
};

const CalendarLogic = ({
  dayCellInfo,
  selectedDate,
  weekData,
  bookingSpotData,
  formatDateString,
  handleCancelBookingClick,
  handleShowBookingModal,
  loadingWeeks,
  setLoadingWeeks,
  fetchWithTokenRefresh2,
  BASE_URL,
  Calendar_api,
  getGuId,
  setWeekData,
  setCalendarRenderKey,
  creditInfoJSX,
  recordsData,
  isPastDate,
  selectedCalendarZoneId,
  ZoneList,
  handleJoinQueueModal,
  handleLeaveQueueModal,
  mapAvailable,
  mapAvailableType,
  setMapAvailable,
  setMapAvailableType,
  loadingDates,
}) => {
  const currentDate = dayCellInfo.date;
  const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  const currentDateString = currentDate.toISOString().slice(0, 10);

  const isSelected = currentDateString === selectedDate;

  const firstDayOfWeek = new Date(currentDate);
  const dayOfWeek = firstDayOfWeek.getDay();
  const diff = firstDayOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  const mondayOfWeek = new Date(firstDayOfWeek.setDate(diff));
  const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

  const weekBookings = weekData[weekKey] || bookingSpotData;
  const hasFetchedData = weekData.hasOwnProperty(weekKey);

  // Debugging logs to inspect data
  console.log("Current Week Key:++++ TestCalendarLogic", weekKey);
  console.log("Week Bookings:++++ TestCalendarLogic", weekBookings);

  const bookingOnDate = weekBookings.find((booking) => {
    const bookingDate = formatDateString(booking.BookingDate);
    return (
      bookingDate.getFullYear() === cellDate.getFullYear() &&
      bookingDate.getMonth() === cellDate.getMonth() &&
      bookingDate.getDate() === cellDate.getDate()
    );
  });

   if (bookingOnDate) {
    const matchedSchedules = bookingOnDate.Schedules || [];
    if (matchedSchedules.length > 0) {
      console.log("Selected SpotId:", matchedSchedules[0].SpotId); // Line 987
    } else {
      console.log("No SpotId found for this date."); // Line 990
    }
  } else {
    console.log("No booking found for this date.");
  }

  const dateNumber = currentDate.getDate();
  const today = new Date();
  const isNextWeek = currentDate > today;

  const [zoneList, setZoneList] = useState([]);
  const [selectedZoneName, setSelectedZoneName] = useState('Select Zone');
  const [multiBookingDates, setMultiBookingDates] = useState([]);

  let fetchButtonJSX = null;
  if (currentDate.getDay() === 1 && isNextWeek && !hasFetchedData) {
    fetchButtonJSX = (
      <button className='ctm-refresh-button'
        onClick={async (event) => {
          event.stopPropagation();
          setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
          try {
            // const zodedata = await ZoneList();

            // const responseCode = zodedata?.Data?.ResponseCode;
            // if (responseCode === 500) {
            //   console.log('zone errordata', responseCode);
            //   return;
            // } else if (responseCode == 200) {
            //   const fetchedZoneList = zodedata?.Data?.records?.zoneList ?? [];
            //   setZoneList(fetchedZoneList);

            //   if (fetchedZoneList.length > 0) {
            //     console.log('Fetched zone list:', multiBookingDates);

            //     const storedZoneIdString = localStorage.getItem(SESSION.selectedZoneIDInCalendarScreen);
            //     const storedZoneId = storedZoneIdString ? parseInt(storedZoneIdString, 10) : null;
            //     if (storedZoneId !== null && selectedCalendarZoneId === 0) {
            //       const defaultZoneData = fetchedZoneList.filter(
            //         (zone) => zone.id === storedZoneId
            //       );
            //       if (defaultZoneData.length > 0) {
            //         setSelectedZoneName(defaultZoneData[0].zoneName);
            //       } else {
            //         setSelectedZoneName(fetchedZoneList[0].zoneName);
            //       }
            //     } else if (selectedCalendarZoneId === 0 && storedZoneId === null && fetchedZoneList.length > 0) {
            //       setSelectedZoneName(fetchedZoneList[0].zoneName);
            //     }
            //   }
            // }

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

             await new Promise((resolve) => setTimeout(resolve, 3000));

            const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                ZoneId: selectedCalendarZoneId,
                GuId: getGuId(),
                BookingStartDate: formattedDate,
                Month: month,
                Year: year,
                TeamMemberGuId: '',
                FilterStartTime: '',
                DeviceId: '2b78fa68-e9b3-4265-ab25-d74a204d583f',
                OsVersion: '10',
                TagsFilter: '',
                ManufactureModel: 'Android SDK built for x86',
                IsGuest: 0,
                FuelFilter: '',
                AppVersion: '12.15.0',
                ShareableFilter: '',
                Language: 'english',
                FilterEndTime: '',
                VehicleTypeFilter: '',
                IsFromAppHome: 0,
                AccessibleFilter: '',
                FacilityFilter: '',
                LogScreenName: "",
                LogActionType: "",
                LogPopup: "",
                LogScreenName: "",
                LogActionType: "",
                LogPopup: ""
              }),
            });

            const data = await response.json();
            if (data?.Data?.Records?.Schedule) {
              setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
            } else {
              setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
            }

            // --- Update mapAvailable and mapAvailableType after refresh ---
            if (setMapAvailable && setMapAvailableType) {
              setMapAvailable(data?.Data?.Records?.MapExist ?? 0);
              setMapAvailableType(data?.Data?.Records?.MapType ?? 0);
            }
            // -------------------------------------------------------------

          } catch (error) {
            console.error('Fetch error:', error);
            setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
          } finally {
            setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
            setCalendarRenderKey((prev) => prev + 1);
          }
        }}
        disabled={loadingWeeks[weekKey]}
      >
        {loadingWeeks[weekKey]
          ? <div id='cal-preloader'><img src={loading} alt='Logo' /></div>
          : <img src={refreshicon} alt='Fetch Week Data' />}
      </button>
    );
  }

  return (
    <CalendarLogicDesign
      dateNumber={dateNumber}
      isSelected={isSelected}
      bookingOnDate={bookingOnDate}
      currentDateString={currentDateString}
      handleCancelBookingClick={handleCancelBookingClick}
      handleShowBookingModal={handleShowBookingModal}
      fetchButton={fetchButtonJSX}
      zoneList={zoneList}
      selectedZoneName={selectedZoneName}
      selectedCalendarZoneId={selectedCalendarZoneId}
      creditInfo={creditInfoJSX}
      recordsData={recordsData}
      isPastDate={isPastDate}
      handleJoinQueueModal={handleJoinQueueModal}
      handleLeaveQueueModal={handleLeaveQueueModal}

       loadingDates={loadingDates}
    />
  );
};

export default CalendarLogic;
